module.exports = __webpack_public_path__ + "static/media/icon-catalog-download.8278a99a.svg";